import ratingPNG from '~/assets/images/communication/rating.png'
import ratingWEBP from '~/assets/images/communication/rating.webp'
import RatingScalePage from '~/pages/communication/libs/RatingScalePage'
import { RATING_QUESTION } from '~/pages/communication/rating/libs/components/RatingCommunication/constants'
import { TPageProps } from '~/shared/types/commonTypes'

const RatingCommunication = (props: TPageProps) => (
  <RatingScalePage
    {...props}
    question={RATING_QUESTION}
    titleI18nKey="onboarding.communicationRating.title"
    subtitleI18nKey="onboarding.communicationRating.subtitle"
    labelWeakI18nKey="onboarding.communicationRating.labelWeak"
    labelPowerfulI18nKey="onboarding.communicationRating.labelPowerful"
    imagePng={ratingPNG}
    imageWebp={ratingWEBP}
    imageAlt="Communication rating"
  />
)

export default RatingCommunication
